import { Component, computed, ElementRef, inject, input, OnInit, output, viewChild, ChangeDetectionStrategy } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { MatchmakingTranslateService } from 'matchmaking/services';

@Component({
    selector: 'matchmaking-form-textarea-input',
    imports: [FormsModule],
    templateUrl: './form-textarea-input.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './form-textarea-input.component.scss'
})
export class FormTextareaInputComponent implements OnInit {
    translateService = inject(MatchmakingTranslateService);
    answer = input.required<string>();
    shouldFocus = input<boolean>(false);
    updateQuestionAnswer = output<string>();
    textAreaElement = viewChild.required<ElementRef>('textAreaElement');

    translations = computed(() => this.translateService.translations());

    ngOnInit() {
        if (this.shouldFocus()) {
            requestAnimationFrame(() => {
                this.textAreaElement().nativeElement.focus();
            });
        }
    }

    public onTextChange(event: string) {
        this.updateQuestionAnswer.emit(event);
    }
}
